import type { Draggable } from "@thisbeyond/solid-dnd";
import type { JSX } from "solid-js";
import { isNil } from "lodash-es";

export const getOverlay = (draggable: Draggable | null) =>
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-call
  !isNil(draggable) ? (draggable.data.overlay() as JSX.Element) : undefined;
